export default {
  API_URL: `${process.env.REACT_APP_API_URL}`,
  googleClientId: `${process.env.REACT_APP_GOOGLE_CLIENT_ID}`,
  reactAppApiUrl: `${process.env.REACT_APP_API_URL}`,
  reactBaseUrl: `${process.env.REACT_APP_BASE_URL}`,
  env: `${process.env.REACT_APP_ENV}`,
  keywordmenu_access_users: `${process.env.REACT_APP_KEYWORDMENU_ACCESS_USERS}`
};
